<template>
  <v-tooltip top open-delay='200' :disabled='!showTooltip'>
    <template v-slot:activator='{ on }'>
      <div v-on='on' class='d-inline-block'>
        <v-chip
          :small='!xSmall'
          :x-small='xSmall'
          label
          :color='status.color'
          :dark='status.dark'
          :class="left ? 'mr-2' : ''"
        >
          <v-icon
            :small='!xSmall'
            :x-small='xSmall'
            left
          >
            {{ status.icon }}
          </v-icon>
          {{ status.text }}
        </v-chip>
      </div>
    </template>
    {{ status.tooltip }}
  </v-tooltip>
</template>

<script>
import _ from 'lodash';

export default {
  name: 'estimate-status-chip',
  props: {
    estimate: {
      required: true
    },
    xSmall: {
      required: false,
      type: Boolean,
      default: false
    },
    left: {
      required: false,
      type: Boolean,
      default: false
    },
    showTooltip: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  computed: {
    status () {
      if (this.estimate) {
        return _.find(this.statusList, s => s.value == this.estimate.status);
      }
      return null;
    },
    statusList () {
      return this.$store.state.misc.globalOptions.estimateStatus;
    }
  }
}
</script>
